import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
	},
	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});
		$('.main-submenu .ds-toggle').on('click', function () {
			if ($(this).parent('li').hasClass('open')) {
				$(this).next(".sub").slideToggle();
				$(this).parent('li').removeClass('open');
			} else {
				$(".main-submenu").find('.sub').slideUp().parent('li').removeClass('open');
				$(this).next(".sub").slideToggle();
				$(this).parent('li').addClass('open');
			}

		});

	},

	methods: {

		navbarToggle: function () {

			var nav = this.$el;

			if (nav.className === "vo-nav-bar") {
				nav.className += " opened";
			} else {
				nav.className = "vo-nav-bar";
			}


		},
		favCount: favCount,
		goSearch: function () {
			if (isBlank(this.name)) {
				window.location.href = 's';
			} else {
				window.location.href = 's#?name=' + encodeURIComponent(this.name);
			}
		}
	}
};